import { Component, HostListener } from "@angular/core";

// @@angularMigrate annotation is missing
@Component({
    template: '',
    standalone: false
})
export abstract class ComponentCanDeactivate {

    abstract canDeactivate(): boolean;

    @HostListener('window:beforeunload', ['$event'])
    unloadNotification($event: BeforeUnloadEvent) {
        if (!this.canDeactivate()) {
            $event.returnValue = true;
        }
    }
}